import { Tag as ChordsTag } from '~/chords/Tag';

import { withClassNameHoc } from '../WithClassNameHoc';

export const Tag = withClassNameHoc(ChordsTag);
